import { render, staticRenderFns } from "./viewDocument.vue?vue&type=template&id=6bca1d86&"
import script from "./viewDocument.vue?vue&type=script&lang=js&"
export * from "./viewDocument.vue?vue&type=script&lang=js&"
import style0 from "./viewDocument.vue?vue&type=style&index=0&id=6bca1d86&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports